/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcOrgResponse } from './vmcOrgResponse';


export interface VmcOrgsPaginatedResponse { 
    current_page_size?: number;
    requested_page_number?: number;
    requested_page_size?: number;
    total_pages?: number;
    total_record_count?: number;
    vmc_orgs?: Array<VmcOrgResponse>;
}

